import { render, staticRenderFns } from "./GasbotAbout.vue?vue&type=template&id=19d3659f&scoped=true"
import script from "./GasbotAbout.vue?vue&type=script&lang=ts"
export * from "./GasbotAbout.vue?vue&type=script&lang=ts"
import style0 from "./GasbotAbout.vue?vue&type=style&index=0&id=19d3659f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d3659f",
  null
  
)

export default component.exports